module.exports = __webpack_public_path__ + "img/Pulpettak.7a342c3d.png";